import { defineWidget } from '../../widget-types';

export const exogroProductCardWidget = defineWidget({
  type: 'code:exogro-product-card',
  schema: {
    label: 'Exogro Product Card',
    description: 'Industrial supply product card with discount badge, price, and CTA button',
    props: {
      brandColor: {
        type: 'color',
        label: 'Brand Color',
        default: '#FF6600',
      },
      ctaLabel: {
        type: 'string',
        label: 'CTA Button Label',
        default: 'เพิ่มลงในตะกร้า',
      },
      currencySymbol: {
        type: 'string',
        label: 'Currency Symbol',
        default: '฿',
      },
      showVendorBadge: {
        type: 'boolean',
        label: 'Show Vendor Badge',
        default: true,
      },
      showSku: {
        type: 'boolean',
        label: 'Show SKU',
        default: true,
      },
    },
    slots: {},
    dataDeps: [],
  },
  nameTh: 'การ์ดสินค้า Exogro',
  descriptionTh: 'การ์ดสินค้าสำหรับร้านค้าอุตสาหกรรม พร้อมป้ายส่วนลด ราคา และปุ่มเพิ่มลงตะกร้า',
  category: 'templates',
  thumbnail: '/widget-thumbnails/code/exogro-product-card.png',
  defaults: {
    type: 'code:exogro-product-card',
    props: {
      brandColor: '#FF6600',
      ctaLabel: 'เพิ่มลงในตะกร้า',
      currencySymbol: '฿',
      showVendorBadge: true,
      showSku: true,
    },
  },
});
